import React from 'react';

const EndBanner = () => {
    return (
        <div className="end-banner-wrapper xpt-16 xpt-lg-20 ">
            <div className="container">
                <div className="d-none d-lg-block">
                    <a href="#">
                    <div
                        className="end-banner-box xpy-8 xpx-10 d-flex justify-content-between align-items-center position-relative">

                        <div className="end-banner-text d-flex align-items-center">
                            <h2 className="xml-4">آیفون ۱۱</h2>
                            <span>مقدار مناسبی از همه چیز</span>
                        </div>
                        <div className="end-banner-btn">
                            <span className="button">بررسی و خرید</span>
                        </div>
                        <div className="end-banner-img position-absolute">
                            <img src="./assets/sample-image/hero__dvsxv8smkkgi_largetall_2x.png" alt="iphone11"/>
                        </div>
                    </div>
                    </a>
                </div>
                <div className="d-block d-lg-none">
                    <div className="end-banner-box-responsive">
                        <div className="row">
                            <div className="col-6 xp-0 xpl-2">
                                <a href="#">
                                <div className="end-banner-img-responsive">
                                    <img src="" alt=""/>
                                </div>
                                </a>
                            </div>
                            <div className="col-6 xp-0 xpr-2">
                                <a href="#">
                                    <div className="end-banner-img-responsive">
                                        <img src="" alt=""/>
                                    </div>
                                </a>
                            </div>
                            <div className="col-6 xp-0 xmt-4 xpl-2">
                                <a href="#">
                                    <div className="end-banner-img-responsive">
                                        <img src="" alt=""/>
                                    </div>
                                </a>
                            </div>
                            <div className="col-6 xp-0 xmt-4 xpr-2">
                                <a href="#">
                                    <div className="end-banner-img-responsive">
                                        <img src="" alt=""/>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EndBanner;
